import "../css/table.css";
import "../css/allResumes.css";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LOAD_ALLRESUMES_REQUEST } from "../reducers/adminIndividual";
import {
  LOAD_ALLUSER_REQUEST,
  LOAD_INDIVIDUAL_REQUEST,
} from "../reducers/adminUser";
const AllResumes = ({ onSelectDetail }) => {
  const dispatch = useDispatch();
  const { allResumes } = useSelector((state) => state.adminIndividual);
  const { userIndividuals, allUsers } = useSelector((state) => state.adminUser);
  const previousComponent = "이력서 목록";
  useEffect(() => {
    // 이력서만 불러오면 아이디·이름·지역을 채울 수 없습니다. 그 정보는 회원
    // 데이터에 있는데 예전엔 이 화면에서 요청을 안 해서, "전체회원" 메뉴를
    // 먼저 들르지 않으면 목록이 통째로 비어 보였습니다.
    dispatch({
      type: LOAD_ALLRESUMES_REQUEST,
    });
    dispatch({
      type: LOAD_ALLUSER_REQUEST,
    });
    dispatch({
      type: LOAD_INDIVIDUAL_REQUEST,
    });
  }, []);

  return (
    <div className="section allResumes">
      <div className="table_container">
        {/* "이력서 제목" 열은 클릭 동작도 없는 단순 표시용이었고, 바로 옆
            "이름" 열과 내용이 겹쳐서 없앴습니다. 이력서 내용은 줄을 클릭하면
            상세 화면에서 볼 수 있습니다. */}
        <div className="row row_head">
          <p>No</p>
          <p>아이디</p>
          <p>이름</p>
          <p>지역</p>
          <p>등록일</p>
        </div>
        {allResumes &&
          userIndividuals &&
          allUsers &&
          allResumes.map((allResume, index) => {
            const userDetail = userIndividuals.find(
              (user) => user.IndividualId === allResume.IndividualId
            );
            const user = allUsers.find(
              (user) => user.id === allResume.IndividualId
            );
            // 주소가 아직 등록되지 않은 구직자가 하나라도 있으면 예전 코드는
            // 여기서 멈춰버려서 목록 전체가 안 나왔습니다.
            const array = userDetail?.user_member_jibunAddress
              ? userDetail.user_member_jibunAddress.split(" ")
              : [];
            const individualId = allResume.IndividualId;
            return (
              <div
                className={
                  index % 2 === 0 ? "content_row row" : "content_row row even"
                }
                onClick={(e) =>
                  onSelectDetail("이력서", {
                    individualId,
                    previousComponent,
                  })
                }
                key={index}
                style={{ cursor: "pointer" }}
              >
                <p>{allResume.id}</p>
                <p>{user?.user_member_id}</p>
                <p>{userDetail?.user_member_name}</p>
                <p>{array[0]}</p>
                <p>{dayjs(allResume.createdAt).format("YYYY.MM.DD")}</p>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default AllResumes;
